import { Image, Link } from '@com-delta-idp/mnx-ui-kit';
import { DisplayProperties } from '../../../models';
import { memberType } from './partners.types';

export interface Partner {
  id: string;
  logo: Image;
  title: string;
  action: Link;
}

export interface Partners extends DisplayProperties {
  title: string;
  action: Link;
  items: Partner[];
  status: memberType;
}
